import React, { useEffect, useState } from 'react';
import './Whatsapp.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import Topbar from './Topbar';
import VOICECALL from '../images/VOICECALL.avif'
import VIDEOCALLICON from '../images/VIDEOCALLICON.png'
import TEXTMSGICON from '../images/TEXTMSGICON.png'
import Languages from './Languages';
import WHATSAPPICONS from '../images/WHATSAPPICONS.png'








export default function Whatsapp() {



 useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // State to manage open/close state of each FAQ item
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index); // Close if already open, otherwise open
  };

  return (
    <>
  
  <div><Navbar /></div>
 
  <div id="whatsapp-page">
    {/* Header Section */}
    <section id="header-section">
      <div class="container text-center">
        <h1 class="animated-title">Contact Us via WhatsApp</h1>
        <p>For any inquiries or to book a session, feel free to reach out to us directly through WhatsApp!</p>
        
      </div>
    </section>





    <section id="ONLINE_PREC">
    <div id="ONLINE_PREC_container">
        <h2>ONLINE Prediction Method</h2>
        <div class="ONLINE_PREC_card">
            <h3>Convenience for Customers</h3>
            <p>
                Now we are doing this Nadi Astrology service through Online for the convenience of our customers.
            </p>
        </div>
        <div class="ONLINE_PREC_card">
            <h3>Avoid Extra Expenses</h3>
            <p>
                Many of our customers told us they did much expense for travel and hotel rooms to get Nadi Astrology by direct visit.
            </p>
        </div>
        <div class="ONLINE_PREC_card">
            <h3>How to Get Nadi Astrology Online?</h3>
            <p>
                Take a clear photo of your thumb and thumbprint also (Male - Right and Female - Left).
                Send it by WhatsApp to <strong>+91 7402167580</strong> or by email to 
                <strong>shivanadiastrologer@gmail.com</strong>. Please select any one.
            </p>
        </div>
        <div class="ONLINE_PREC_card">
            <h3>Fixing an Appointment</h3>
            <p>
                Then we will fix an appointment to search your Nadi leaf by voice or video call.
            </p>
        </div>
        <div class="ONLINE_PREC_card">
            <h3>Payment and Delivery</h3>
            <p>
                After getting your Nadi leaf, make payment for your Nadi prediction package and chapters. We send your 
                Nadi predictions through voice mail in your convenient language.
            </p>
        </div>
    </div>
</section>






    {/* WhatsApp Options Section */}
    <section id="whatsapp-options-section">
      <div class="container">
        <h2>How Would You Like to Connect with Us?</h2>
        <p>Choose your preferred method to contact us on WhatsApp. We offer voice calls, video calls, or text messaging—whatever works best for you!</p>
       <center>
        <img src={WHATSAPPICONS} alt='whatsapp icons' title='whatsapp icons' id='whats'/>
        <h5>Connect With WhatsApp</h5>
        </center>
        <div class="whatsapp-options">
          <div class="whatsapp-option">
            <a href="https://wa.me/1234567890?text=Hi, I would like to inquire about Shiva Nadi Astrology." target="_blank">
              <div class="icon">
                <img src={VOICECALL} alt="Voice Call Icon" />
              </div>
              <h3>Voice Call</h3>
              <p>Call us directly for a voice consultation or any inquiries.</p>
            </a>
          </div>

          <div class="whatsapp-option">
            <a href="https://wa.me/1234567890?text=Hi, I would like to inquire about Shiva Nadi Astrology." target="_blank">
              <div class="icon">
                <img src={VIDEOCALLICON} alt="Video Call Icon" />
              </div>
              <h3>Video Call</h3>
              <p>Have a face-to-face conversation with our expert astrologers via video call.</p>
            </a>
          </div>

          <div class="whatsapp-option">
            <a href="https://wa.me/1234567890?text=Hi, I would like to inquire about Shiva Nadi Astrology." target="_blank">
              <div class="icon">
                <img src={TEXTMSGICON} alt="Text Message Icon" />
              </div>
              <h3>Text Message</h3>
              <p>Send us a message with your questions and we’ll get back to you promptly.</p>
            </a>
          </div>
        </div>
      </div>
    </section>















    {/* Extra Content Section */}
    <section id="extra-content-section">
      <div class="container text-center">
       <h2 style={{ color: "white" }}>Why Choose Us?</h2>


        <ul class="features-list">
          <li>Instant communication through WhatsApp.</li>
          <li>Quick responses to all your queries.</li>
          <li>Convenient voice and video consultations at your convenience.</li>
          <li>Experience personalized astrology sessions with ease.</li>
        </ul>
      </div>
    </section>
  </div>
  <section id="contact-info">
  <h2>Contact Us</h2>
  <div class="contact-container">
    <div class="contact-item">
      <i class="fas fa-map-marker-alt"></i>
      <h3>Office Address</h3>
      <p>LIG- B, Plot No: 204, Dr. AS Rao Nagar Rd, beside SUB POST OFFICE, Anupuram Colony, A. S. Rao Nagar, Hyderabad, Secunderabad, Telangana 500062</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact</h3>
      <p>Phone: +91 74021 67580<br/>Email:shivanadiastrologer@gmail.com</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-map"></i>
      <h3>Map</h3>
      <p>
      <a href="https://www.google.com/maps?q=LIG-+B,+Plot+No:+204,+Dr.+AS+Rao+Nagar+Rd,+beside+SUB+POST+OFFICE,+Anupuram+Colony,+A.+S.+Rao+Nagar,+Hyderabad,+Secunderabad,+Telangana+500062" target="_blank">View on Google Maps</a>

      </p>
    </div>
  </div>
</section>
  {/* <div><Footer /></div> */}
  
</>

  )
}
